<template>
<el-dialog title="选择明细信息" width="80%" :visible.sync="viewData.visible" :close-on-click-modal="false" :before-close="handleClose" append-to-body>
    <div class="content-body tenant-settings">
        <!-- <div class="" style="background: red ;display: none"> -->
        <div class="">
            <div v-loading="dataListLoading">
                <el-table :data="deviveryPartList" row-key="id" size="small" @selection-change="selectionChangeHandle" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }">
                    <el-table-column label="选择" type="selection" width="55">
                        <!-- <el-table-column label="选择" type="selection" :selectable='checkboxSelect' width="55"> -->
                    </el-table-column>
                    <el-table-column prop="zexpos" header-align="center" align="right" label="ASN行项" width="80">
                            <template slot-scope="scope">
                                <span>{{scope.row.zexpos = ((pageIndex - 1) * pageSize) + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <!-- 供应商填写 -->
                        <!-- <el-table-column prop="orderCode" header-align="center" align="left" label="订单编码" width="150">
                        </el-table-column> -->
                        <!-- 供应商填写 -->
                        <el-table-column prop="posnr" header-align="center" align="left" label="交货单行项号" width="120">
                        </el-table-column>
                        <el-table-column prop="partCode" header-align="center" align="left" label="物料号" width="120">
                        </el-table-column>
                        <!-- 供应商填写 -->
                        <el-table-column prop="partName" header-align="center" align="left" label="物料名称" width="150">
                        </el-table-column>
                        <el-table-column prop="syncMessage" header-align="center" align="left" label="同步失败原因" width="150">
                        </el-table-column>
                        <el-table-column prop="count" header-align="center" align="center" label="订单数量" width="80">
                        </el-table-column>
                        <el-table-column prop="asnRemaining" header-align="center" align="center" label="ASN剩余交货数量" width="120">
                        </el-table-column>
                        <!-- <el-table-column prop="asncode" header-align="center" align="left" label="ASN编码">
                    </el-table-column> -->
                        <!-- 交货数量 -->
                        <el-table-column prop="lfimg" header-align="center" align="center" width="100" label="交货数量">
                            <template slot-scope="scope">
                                <ctl-number v-if="scope.row.show" v-model="scope.row.lfimg" placeholder="交货数量"></ctl-number>
                                <span v-else>{{scope.row.lfimg}}</span>
                            </template>
                        </el-table-column>
                        <!-- 单位 -->
                        <el-table-column prop="unit" header-align="center" align="center" label="单位" width="60">
                            <template slot-scope="scope">
                                <span>{{getUnitName(scope.row.unit)}}</span>
                            </template>
                        </el-table-column>
                        <!-- 供应商填写（纸箱、货架等） -->
                        <el-table-column prop="boxType" header-align="center" align="center" width="100" label="箱种">
                            <template slot-scope="scope">
                                <el-input size="small" v-if="scope.row.show" v-model="scope.row.boxType" placeholder="箱种"></el-input>
                                <span v-else>{{scope.row.boxType}}</span>
                            </template>
                        </el-table-column>
                        <!-- 供应商填写 -->
                        <el-table-column prop="inCount" header-align="center" align="right" width="80" label="收容数">
                            <template slot-scope="scope">
                                <ctl-number v-if="scope.row.show" v-model="scope.row.inCount" placeholder="收容数"></ctl-number>
                                <span v-else>{{scope.row.inCount}}</span>
                            </template>
                        </el-table-column>
                        <!-- 供应商填写 -->
                        <el-table-column prop="deliveredBoxCount" header-align="center" align="right" width="80" label="送货箱数">
                            <template slot-scope="scope">
                                <ctl-number v-if="scope.row.show" v-model="scope.row.deliveredBoxCount" placeholder="送货箱数"></ctl-number>
                                <span v-else>{{scope.row.deliveredBoxCount}}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="meins" header-align="center" align="center" label="基本计量单位" width="150">
                            <template slot-scope="scope">
                                <span>{{scope.row.meins}}</span>
                            </template>
                        </el-table-column> -->
                        <!-- 供应商填写 -->
                        <el-table-column prop="hsdat" header-align="center" align="center" width="140" label="生产日期">
                            <template slot-scope="scope">
                                <el-date-picker size="small" v-if="scope.row.show" v-model="scope.row.hsdat" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                                </el-date-picker>
                                <span v-else>{{ dateFormatValue(scope.row.hsdat) }}</span>
                            </template>
                        </el-table-column>
                        <!-- 供应商填写 -->
                        <el-table-column prop="vfdat" header-align="center" align="center" label="货架寿命到期日" width="140">
                            <template slot-scope="scope">
                                <el-date-picker size="small" v-if="scope.row.show" v-model="scope.row.vfdat" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="选择日期">
                                </el-date-picker>
                                <span v-else>{{ dateFormatValue(scope.row.vfdat) }}</span>
                            </template>
                        </el-table-column>
                        <!-- 供应商选填（生产批次） -->
                        <el-table-column prop="lichn" header-align="center" align="left" width="150" label="生产批次">
                            <template slot-scope="scope">
                                <el-input size="small" v-if="scope.row.show" v-model="scope.row.lichn" placeholder="生产批次"></el-input>
                                <span v-else>{{scope.row.lichn}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="werks" header-align="center" align="left" label="工厂" width="60">
                            <template slot-scope="scope">
                                <span>{{ scope.row.werks }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name2" header-align="center" align="left" label="工厂描述" width="150">
                            <template slot-scope="scope">
                                <span>{{ getFactoryName(scope.row.werks) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderCode" header-align="center" align="left" label="订单编码" width="150">
                        </el-table-column>
                        <!-- <el-table-column prop="deleteFlag" header-align="center" align="left" label="删除标记" width="150">
                             <template slot-scope="scope">
                                <span>{{getDeleteFlagName(scope.row.deleteFlag)}}</span>
                            </template>
                        </el-table-column> -->
                </el-table>
            </div>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align:right" class="mt15 mb15">
            </el-pagination>
        </div>
    </div>
    <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
            <el-button size="small" @click="cancel()">
                取消
            </el-button>
            <!-- 询价中 -->
            <el-button size="small" plain type="primary" @click="confirm()">
                确认
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import Vue from 'vue'
import {
    // getSupplierList,
    getStreetList,
    getGroupList
} from '@/controller/order'
import {
    getAddressList,
    getSupplierList
} from '@/controller/delivery'
import {
    ASN_STATUS,
    DIALOG_CLOSED_TYPE,
    getAsnStatusByValue
} from "@/utils/const";
import {
    getDeliveryById,
    editDelivery,
    createDelivery,
    getDeliveryPartList,
    deletePartList,
    saveDeliveryPart,
    passDelivery,
    submitDelivery,
    saveDeliveryPartList,
    closeDeliveryPartList
} from "@/controller/delivery";
import {
    getUnitList,
    getFactoryList
} from '@/controller/systemData'
import AddOrUpdateDeliveryPart from "./delivered-appart-add-or-update";
import SelectOrderPart from "./select-order-part"
import DeliveredRejectReason from "./delivered-reject-reason";
import moment from 'moment'
import {
    fromStringWithSourceMap
} from 'source-list-map';
import {
    readFile, read
} from 'fs';
require("@/mock/mockDelivery");
import CtlNumber from '@/views/common/ctl-number'
export default {
    props: {
        partFormData: Object,
    },
    data() {
        return {
            handleSaveLoading: false,
            show: false,
            FILE_BIZ_TYPE: 11,
            viewFlag: '',
            viewData: {
                visible: false,
                width: "",
            },
            dataListLoading: false,
            ASN_STATUS: ASN_STATUS,
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            getAsnStatusByValue: getAsnStatusByValue,
            dataList: [],
            unitList: [],
            selectPartList: [],
            factoryList: [],
            supplierList: [],
            streetList: [],
            pageIndex: 1,
            pageSize: 50,
            totalPage: 0,
            deviveryPartList: [],
            groupList: [],
            addOrUpdateDeliveryPartVisible: false,
            selectOrderPartVisible: false,
            createTime: '',
            lichnInfo: '',
            tabPanel:{},
            dataForm: {
                id: 0,
                asncode: '',
                supplierCode: '',
                supplierName: '',
                deliveryAddress: '',
                recieveyDate: '',
                deliveryDate: '',
                asnStatus: '',
                remark: '',
                deliveryId: '',
                syncStatus: '',
                rejectReason: '',
                groupCode: '',
                innerCode: '',
                groupName: ''
            },
            dataRule: {
                deliveryDate: [{
                    required: true,
                    message: "发货日期不能为空",
                    trigger: "blur",
                }, ],
                recieveyDate: [{
                    required: true,
                    message: "到货日期不能为空",
                    trigger: "blur"
                }],
                tenantName: [{
                    required: true,
                    message: "请先在页面顶部导航栏选择租户",
                    trigger: "blur",
                }, ],
                groupCode: [{
                    required: true,
                    message: "采购组不能为空",
                    trigger: "change",
                }, ],
            },
            recievePicker: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            }
        };
    },
    methods: {
        init(id, innerCode) {
            this.dataForm.id = id;
            this.dataForm.innerCode = innerCode;
            this.viewData.visible = true;
            if (this.dataForm.id == '') {
                return
            }
            this.getDataList();
            this.getUnitList();
            this.getFactoryList();
        },
        getDataList() {
            getDeliveryPartList({
                deliveryId: this.dataForm.id,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.deviveryPartList = data.body.records;
                    this.totalPage = data.body.total
                } else {
                    this.deviveryPartList = [];
                    this.totalPage = 0
                }
            });
        },
        dateFormatValue: function (value) {
            if (value == undefined) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        onClosed(params) {
            return
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.factoryDesc = ""
            })
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            this.$emit("refreshDataList");
            this.onClosed({
                option,
                sender: this,
                data: "OK",
            });
            this.viewData.visible = false;
        },
        confirm() {
            this.loading = true
            if (!this.selectPartList) {
                this.$message.error("请选择物料消息")
                return
            }
            if(this.selectPartList.length === 0) {
                this.selectPartList = []
                this.close(DIALOG_CLOSED_TYPE.CLOSE);
                return
            }
            const loading = this.$loading({
                lock: true,
                text: '正在保存',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const params = this.selectPartList.map(v => {
                return {
                    vbeln: this.dataForm.innerCode,
                    werks: v.werks,
                    posnr: v.posnr
                }
            })
            closeDeliveryPartList(params).then((data) => {
                if (data && data.code === "00") {
                    this.result = "OK"
                    this.selectPartList = []
                    this.getDataList();
                    // this.close(DIALOG_CLOSED_TYPE.CONFIRM);
                    loading.close();
                } else {
                    this.$message.error(data.msg);
                    loading.close();
                }

            }).catch(e => {
                console.error(e)
                loading.close();
            }).finally(() => {
                this.loading = false
                loading.close();
            })
        },
        setFactoryName(val) {
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            this.dataForm.deliveryAddress = factory ? factory.address : ''
        },
        getFactoryName(val) {
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            return factory ? factory.factoryDesc : ''
        },
        getDeleteFlagName(val) {
            return val === 1 ? '已删除' : ''
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        getTaxCodeName(code) {
            const taxCode = this.unitList.find(taxCode => taxCode.code === code)
            return taxCode ? taxCode.name : ''
        },
        getAsnLfimg(code) {
            return code ? code : '0'
        },
        getElikz(code) {
            return code ? "已完成" : '未完成'
        },
        getStorePositionName(code) {
            const storePosition = this.storePositionTypeList.find(storePosition => storePosition.storeAddress === code)
            return storePosition ? storePosition.storeName : ''
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.selectPartList = val
        },
        currentChange(currentRow) {
            this.currentRow = currentRow;
        },
        handleClose(){
            this.viewData.visible = false
            this.$emit('refreshDataList')
        },
        // //禁用checkbox
        // checkboxSelect(row, rowIndex) {
        //     return row.deleteFlag === 1 ? false : true
        // },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD前");
        },
    }
}
</script>
